/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback, lazy } from 'react'
import classNames from 'classnames'
import { getS3, getDataTicket } from '../../service/callAPI'

import {
  Container,
  Grid,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Button,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  useStyles,
  SectionWidget,
  Title,
  SubAccordion,
  SubAccordionSummary,
  SubAccordionDetails,
} from './styled'
const LogoBrand = lazy(() => import('../../components/LogoBrand'))
const Question = lazy(() => import('./Question'))
const SubQuestion = lazy(() => import('./SubQuestion'))

function formatAMPM(date) {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  const strTime = hours + ':' + minutes + ' ' + ampm
  return strTime
}

function conditionDisplay({
  detail,
  external_link,
  file,
  poll_link,
  question_link,
  questions,
  speaker,
}) {
  let result = true
  if (
    detail ||
    external_link.url ||
    file.url ||
    poll_link.url ||
    question_link.url ||
    questions.length > 0 ||
    speaker.length > 0
  ) {
    result = false
  }
  return result
}

function SubCardWidget({ subsection, parentIndex, allData, qrCode, onDataChange }) {
  const [expanded, setExpanded] = useState(null)
  const classes = useStyles()

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }
  return (
    <div>
      {subsection.length > 0 &&
        subsection.map((sub, key) => (
          <SubAccordion
            key={`${sub.title}-${sub.id}`}
            expanded={expanded === key}
            onChange={handleChange(key)}
            disabled={conditionDisplay(sub)}
          >
            <SubAccordionSummary
              aria-controls={`${key}d-content`}
              id={`${key}d-header`}
              bgcolor={sub.bg_color}
              textcolor={sub.text_color}
              sx={{
                '& .MuiAccordionSummary-expandIconWrapper': {
                  display: conditionDisplay(sub) ? 'none' : 'flex',
                },
              }}
            >
              <Grid container alignItems="baseline">
                {sub.time && (
                  <Grid item xs={12} sm={2}>
                    <Typography sx={{ fontWeight: 700, fontSize: '14px' }}>{sub.time}</Typography>
                  </Grid>
                )}
                <Grid item xs={12} sm={10}>
                  <Typography sx={{ fontWeight: 700 }}>{sub.title}</Typography>
                </Grid>
              </Grid>
            </SubAccordionSummary>
            <SubAccordionDetails bgcolor="#ffffff">
              <div className={classes.sectionContainer}>
                <div className={classNames(classes.sectionRoot, classes.sectionColumn)}>
                  <SectionWidget
                    style={{
                      paddingLeft: '0px',
                      paddingRight: '0px',
                      paddingTop: '0px',
                      paddingBottom: '15px',
                    }}
                    widgetColor="transparent"
                  >
                    {sub.detail && (
                      <Title
                        style={{ marginTop: '30px' }}
                        textColor="#15261E"
                        className={classNames(
                          classes.sectionRoot,
                          classes.sectionWidgetElement,
                          classes.detailText,
                        )}
                      >
                        <div
                          className={classes.sectionWidgetContainer}
                          dangerouslySetInnerHTML={{
                            __html: sub.detail,
                          }}
                        />
                      </Title>
                    )}
                    <section style={{ width: '100%' }} className={classes.sectionRoot}>
                      <Grid container>
                        {sub.speaker.length > 0 &&
                          sub.speaker.map((spk, index) => (
                            <Grid key={`${index}-${spk.name}`} item xs={12} sm={6}>
                              <div style={{ padding: '0px' }} className={classes.widgetInner}>
                                <Title
                                  textColor="#15261E"
                                  className={classNames(
                                    classes.sectionRoot,
                                    classes.sectionWidgetElement,
                                    classes.titleInner,
                                  )}
                                >
                                  <div className={classes.sectionWidgetContainer}>{spk.name}</div>
                                </Title>
                                <Title
                                  textColor="#15261E"
                                  className={classNames(
                                    classes.sectionRoot,
                                    classes.sectionWidgetElement,
                                    classes.subTitleInner,
                                  )}
                                >
                                  <div className={classes.sectionWidgetContainer}>
                                    <strong>{spk.position}</strong>
                                    <br />
                                    {spk.company}
                                    <br />
                                    <em>{spk.sub_position}</em>
                                  </div>
                                </Title>
                              </div>
                            </Grid>
                          ))}
                      </Grid>
                    </section>
                    {sub.questions.length > 0 && (
                      <section style={{ width: '100%' }} className={classes.sectionRoot}>
                        <SubQuestion
                          questions={sub.questions}
                          parentIndex={parentIndex}
                          questIndex={key}
                          textColor="#15261E"
                          widgetColor={sub.bg_color}
                          allData={allData}
                          allDataSubsections={subsection}
                          qrCode={qrCode}
                          file={sub.file}
                          onDataChange={onDataChange}
                        />
                      </section>
                    )}
                  </SectionWidget>
                </div>
              </div>
            </SubAccordionDetails>
          </SubAccordion>
        ))}
    </div>
  )
}

function SectionCard({
  title,
  bg_color,
  text_color,
  start,
  end,
  speaker,
  detail,
  questions,
  index,
  allData,
  qrCode,
  file,
  external_link,
  poll_link,
  question_link,
  time,
  onDataChange,
  subsection,
  background,
  accordionProps,
}) {
  const classes = useStyles({ widgetColor: bg_color, textColor: text_color })
  const onClickLink = (key) => (event) => {
    console.log('🚀 ~ file: Event.js:330 ~ onClickLink ~ key:', key)
    event.preventDefault()
    const newDate = new Date().valueOf()
    let mayDatas = [...allData]
    mayDatas[index][key] = {
      ...mayDatas[index][key],
      click: [...mayDatas[index][key].click, newDate],
    }
    console.log('🚀 ~ file: Event.js:332 ~ onClickLink ~ mayDatas:', mayDatas)
    getDataTicket({
      code: qrCode,
      actionType: 'update',
      action: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      event_id: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      DATA_015: JSON.stringify(mayDatas),
    }).then((res) => {
      console.log('🚀 ~ file: Event.js:345 ~ onClickLink ~ res:', res)
      let url = mayDatas[index][key]['url']
      if (!url.match(/^https?:\/\//i)) {
        url = 'http://' + url
      }
      window.open(url, '_blank')
    })
  }
  return (
    <section key={title} className={classNames(classes.sectionRoot, classes.sectionChild)}>
      <div className={classes.sectionContainer}>
        <div className={classNames(classes.sectionRoot, classes.sectionColumn)}>
          <SectionWidget
            style={{
              borderRadius: '5px',
              background,
            }}
            widgetColor={bg_color}
          >
            {questions.length > 0 ||
            external_link.url ||
            poll_link.url ||
            question_link.url ||
            subsection.length > 0 ? (
              <section style={{ width: '100%' }} className={classes.sectionRoot}>
                <Accordion
                  sx={{ boxShadow: 'none' }}
                  aria-controls={`${index}d-content`}
                  id={`${index}d-header`}
                  {...accordionProps}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          color: text_color,
                          display: accordionProps.onChange === null && 'none',
                        }}
                      />
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                      padding: '0px 10px',
                      alignItems: 'baseline',
                      '& .MuiAccordionSummary-content': { flexDirection: 'column' },
                    }}
                  >
                    <div>
                      <Title
                        style={{ marginBottom: 0 }}
                        textColor={text_color}
                        className={classNames(
                          classes.sectionRoot,
                          classes.sectionWidgetElement,
                          classes.title,
                        )}
                      >
                        <div className={classes.sectionWidgetContainer}>{title}</div>
                      </Title>
                    </div>
                    <div>
                      {detail && (
                        <Title
                          textColor={text_color}
                          className={classNames(
                            classes.sectionRoot,
                            classes.sectionWidgetElement,
                            classes.detailText,
                          )}
                        >
                          <div
                            className={classes.sectionWidgetContainer}
                            dangerouslySetInnerHTML={{
                              __html: detail,
                            }}
                          />
                        </Title>
                      )}
                    </div>

                    {/* <Typography
                      sx={{
                        color: text_color,
                        fontSize: '14px',
                        fontWeight: '400',
                        lineHeight: '20px',
                      }}
                    >
                      <strong>See more</strong>
                    </Typography> */}
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '10px 10px 20px' }}>
                    <Box
                      sx={{ borderTop: subsection.length > 0 ? 'none' : `2px solid ${text_color}` }}
                    >
                      {external_link.url && (
                        <Box
                          className={classes.widgetInner}
                          sx={{ padding: '0px', marginTop: '30px' }}
                        >
                          {/* div className={classes.widgetInner} */}
                          <Title
                            textColor={text_color}
                            className={classNames(
                              classes.sectionRoot,
                              classes.sectionWidgetElement,
                              classes.subTitleInner,
                            )}
                          >
                            <div className={classes.sectionWidgetContainer}>
                              <Link
                                href={file?.url}
                                onClick={onClickLink('external_link')}
                                sx={{
                                  color: text_color,
                                  textDecorationColor: text_color,
                                }}
                              >
                                <strong>{external_link.name}</strong>
                              </Link>
                            </div>
                          </Title>
                        </Box>
                      )}
                      {poll_link.url && (
                        <Box
                          className={classes.widgetInner}
                          sx={{ padding: '0px', marginTop: '30px' }}
                        >
                          {/* div className={classes.widgetInner} */}
                          <Title
                            textColor={text_color}
                            className={classNames(
                              classes.sectionRoot,
                              classes.sectionWidgetElement,
                              classes.subTitleInner,
                            )}
                          >
                            <div
                              style={{ textAlign: 'center' }}
                              className={classes.sectionWidgetContainer}
                            >
                              <Button
                                // href={file?.url}
                                onClick={onClickLink('poll_link')}
                                sx={{
                                  color: '#15261E',
                                  textDecorationColor: text_color,
                                  backgroundColor: '#e0c651',
                                  '&:hover': {
                                    color: '#15261E',
                                    backgroundColor: '#e0c651',
                                  },
                                }}
                              >
                                <strong>{poll_link.name}</strong>
                              </Button>
                            </div>
                          </Title>
                        </Box>
                      )}
                      {question_link.url && (
                        <Box
                          className={classes.widgetInner}
                          sx={{ padding: '0px', marginTop: '30px' }}
                        >
                          {/* div className={classes.widgetInner} */}
                          <Title
                            textColor={text_color}
                            className={classNames(
                              classes.sectionRoot,
                              classes.sectionWidgetElement,
                              classes.subTitleInner,
                            )}
                          >
                            <div
                              style={{ textAlign: 'center' }}
                              className={classes.sectionWidgetContainer}
                            >
                              <Button
                                // href={file?.url}
                                onClick={onClickLink('question_link')}
                                sx={{
                                  color: '#15261E',
                                  textDecorationColor: text_color,
                                  backgroundColor: '#e0c651',
                                  '&:hover': {
                                    color: '#15261E',
                                    backgroundColor: '#e0c651',
                                  },
                                }}
                              >
                                <strong>{question_link.name}</strong>
                              </Button>
                            </div>
                          </Title>
                        </Box>
                      )}
                      {questions.length > 0 && (
                        <section style={{ width: '100%' }} className={classes.sectionRoot}>
                          <Question
                            questions={questions}
                            questIndex={index}
                            textColor={text_color}
                            widgetColor={bg_color}
                            allData={allData}
                            qrCode={qrCode}
                            file={file}
                            onDataChange={onDataChange}
                          />
                        </section>
                      )}
                      {subsection.length > 0 && (
                        <SubCardWidget
                          subsection={subsection}
                          parentIndex={index}
                          allData={allData}
                          qrCode={qrCode}
                          onDataChange={onDataChange}
                        />
                      )}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </section>
            ) : null}
          </SectionWidget>
        </div>
      </div>
    </section>
  )
}

function Event({ qrCode }) {
  const [datas, setDatas] = useState([])
  const [code, setCode] = useState('')
  const [expanded, setExpanded] = useState(null)

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }
  const classes = useStyles()

  const fetchData = useCallback(async (code, items) => {
    getDataTicket({
      action: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      actionType: 'check',
      code: code,
      event_id: 'da999d7a-c164-a21a-bcf7-32cb27298727',
    }).then((res) => {
      if (res.code === 0) {
        const arryData = JSON.parse(res.data.DATA_015)
        console.log('🚀 ~ file: Event.js:403 ~ fetchData ~ arryData:', arryData)
        if (arryData[0].length !== 0) {
          console.log('if')
          const result = items.map((item, index) => {
            return {
              ...item,
              subsection: item.subsection.map((sub, indexS) => {
                return {
                  ...sub,
                  is_submited: arryData[index]['subsection'][indexS]?.is_submited || false,
                  file: {
                    ...sub.file,
                    click: arryData[index]['subsection'][indexS]?.file.click,
                  },
                  questions: sub.questions.map((question, indexQS) => {
                    return {
                      ...question,
                      answer: arryData[index]['subsection'][indexS]['questions'][indexQS].answer,
                    }
                  }),
                }
              }),
              is_submited: arryData[index]?.is_submited || false,
              questions: item.questions.map((question, indexQ) => {
                return {
                  ...question,
                  answer: arryData[index]['questions'][indexQ].answer,
                }
              }),
              file: {
                ...item.file,
                click: arryData[index]?.file.click,
              },
              external_link: {
                ...item.external_link,
                click: arryData[index]?.external_link.click,
              },
              poll_link: {
                ...item.poll_link,
                click: arryData[index]?.poll_link.click,
              },
              question_link: {
                ...item.question_link,
                click: arryData[index]?.question_link.click,
              },
            }
          })
          console.log('🚀 ~ file: Event.js:417 ~ result ~ result:', result)
          setDatas(result)
        } else {
          console.log('else')
          setDatas(items)
        }
        // const result =
      } else {
        window.location.href = `login`
      }
    })
  })
  useEffect(() => {
    const local = JSON.parse(localStorage.getItem('code'))
    const valueCode = qrCode || local?.code
    if (valueCode) {
      getS3().then((res) => {
        setCode(valueCode)
        fetchData(valueCode, res.data)
        // setDatas(res.data)
      })
    } else {
      window.location.href = `login`
    }
  }, [])
  // useEffect(() => {

  // },[])
  // console.log('data', datas)

  return (
    datas.length > 0 && (
      <Container>
        <div className={classes.root}>
          <div className={classes.sectionContainer}>
            <LogoBrand />
          </div>

          {datas.map((data, index) => (
            <SectionCard
              key={`${index}-${data.title}`}
              index={index}
              allData={datas}
              qrCode={code}
              onDataChange={setDatas}
              accordionProps={{
                expanded:
                  data.questions.length > 0 || data.subsection.length > 0
                    ? expanded === index
                    : true,
                onChange:
                  data.questions.length > 0 || data.subsection.length > 0
                    ? handleChange(index)
                    : null,
              }}
              {...data}
            />
          ))}
        </div>
      </Container>
    )
  )
}

export default Event
